import { type ReactNode } from "react";
import { FormControl, FormLabel, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { APP_FORM_DEFAULTS } from "./constants";
import { chartOptionToggleGroupSx } from "../../lib/ui/formLayout";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

export type AppToggleOption = {
  value: string;
  label: string;
  disabled?: boolean;
  icon?: ReactNode;
};

type Props = {
  label?: string;
  hideLabel?: boolean;
  value: string;
  options: AppToggleOption[];
  disabled?: boolean;
  onChange: (value: string) => void;
};

/** MUI toggle button group for small fixed-choice fields (environment, strategy, etc.). */
export default function AppToggleField({
  label,
  hideLabel = false,
  value,
  options,
  disabled,
  onChange,
}: Props) {
  const custom = useAppCustomStyles();
  return (
    <FormControl
      fullWidth={APP_FORM_DEFAULTS.fullWidth}
      margin={APP_FORM_DEFAULTS.margin}
      size={APP_FORM_DEFAULTS.size}
      disabled={disabled}
    >
      {!hideLabel && label ? (
        <FormLabel sx={custom.components.appToggleField.label}>
          {label}
        </FormLabel>
      ) : null}
      <ToggleButtonGroup
        exclusive
        fullWidth
        size="small"
        value={value}
        onChange={(_, next) => {
          if (next) onChange(next);
        }}
        sx={chartOptionToggleGroupSx}
      >
        {options.map((option) => (
          <ToggleButton key={option.value} value={option.value} disabled={option.disabled}>
            <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
              {option.icon}
              <span>{option.label}</span>
            </Stack>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </FormControl>
  );
}
